<template>
  <div class="lang_switcher">
    <a
      href="#"
      :class="{ active: i18n.locale === 'es' }"
      @click.prevent="i18n.setLocale('es')"
      >ES</a
    >
    <span class="sep">|</span>
    <a
      href="#"
      :class="{ active: i18n.locale === 'en' }"
      @click.prevent="i18n.setLocale('en')"
      >EN</a
    >
  </div>
</template>

<script>
import { i18n } from "@/i18n";
export default {
  name: `LanguageSwitcher`,
  data() {
    return { i18n };
  },
};
</script>

<style scoped>
.lang_switcher {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 14px;
}

.lang_switcher a {
  text-decoration: none;
  color: #a2a2a2;
  padding: 2px 4px;
  transition: all 0.3s ease;
}

.lang_switcher a:hover {
  color: #fff;
}

.lang_switcher a.active {
  color: var(--main-color);
  font-weight: 700;
}

.lang_switcher .sep {
  color: rgba(255, 255, 255, 0.25);
}
</style>
